<template>
  <section id="response_message" class="py-8 px-4">
    <!-- Headline START -->
    <div class="md:pb-8">
      <h2 class="text-center speedee-bd text-3xl">
        Profitiere jetzt von Family PLUS:
      </h2>
      <p class="text-center text-lg md:text-2xl font-light md:pb-4">
        In nur wenigen Schritten zu deinen exklusiven<br />
        Family PLUS Angeboten
      </p>
    </div>
    <!-- Headline END -->
    <div
      class="md:w-9/12 m-auto shadow-mcd-form rounded-mcd-lg px-4 md:px-12 lg:px-24 xl:px-48"
    >
      <!-- preloader START -->
      <Preloader v-if="submitStatus == 'LOADING'" />
      <!-- preloader END -->
      <!-- Success Message START -->
      <RegistrationSuccessMessage v-if="submitStatus == 'OK'" />
      <!-- Success Message END -->
      <div v-if="submitStatus != 'OK'" class="py-16">
        <!-- E-Mail START -->
        <div class="md:px-20">
          <input
            class="w-full bg-white h-14 px-5 rounded focus:outline-none"
            :class="[
              submitStatus == 'ERROR' && !$v.email.email ? 'error' : '',
              submitStatus == 'ERROR' && !$v.email.required ? 'error' : '',
            ]"
            type="email"
            name="email"
            placeholder="E-Mail Adresse*"
            v-model.trim="$v.email.$model"
          />
          <div class="text-red-600 text-sm pt-2">
            <p v-if="submitStatus == 'ERROR' && !$v.email.required">
              Erforderlich
            </p>
            <p v-if="submitStatus == 'ERROR' && !$v.email.email">
              Eine gültige E-Mail-Adresse ist erforderlich.
            </p>
          </div>
          <div class="speedee pt-6 text-center">
            Wenn du deine persönlichen Daten (z.B. Adresse) ändern, oder dich
            für zusätzliche Angebote anmelden möchtest: einfach nochmal ganz neu
            hier registrieren. Deine alten Daten werden überschrieben.
          </div>
        </div>
        <!-- E-Mail END -->
        <!-- NL START -->
        <div class="pt-8">
          <!-- Check box NL START -->
          <label class="flex justify-start items-start pb-4">
            <div
              class="rounded-md w-6 h-6 flex flex-shrink-0 justify-center items-center mr-4"
              :class="[
                nl.isVisible ? 'bg-mcdonalds-yellow' : 'bg-mcdonalds-gray',
              ]"
            >
              <input
                type="checkbox"
                name="nl"
                class="opacity-0 absolute"
                v-model="nl.isVisible"
              />
              <svg
                class="fill-current stroke-current stroke-2 hidden w-3 h-3 text-white pointer-events-none"
                viewBox="0 0 20 20"
              >
                <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
              </svg>
            </div>
            <div>
              <span class="speedee-bd"
                >Anmeldung zum Family Plus Newsletter</span
              >
              - immer top informiert über alle Family Highlights bei McDonald’s.
            </div>
          </label>
        </div>
        <!-- Check box NL END -->
        <!-- NL END -->
        <!-- GB START -->
        <div class="pt-8">
          <!-- Check box GB START -->
          <label
            class="flex justify-start items-start pb-4"
            @click="submitStatus = null"
          >
            <div
              class="rounded-md w-6 h-6 flex flex-shrink-0 justify-center items-center mr-4"
              :class="[newEdit ? 'bg-mcdonalds-yellow' : 'bg-mcdonalds-gray']"
            >
              <input
                type="checkbox"
                name="gb"
                class="opacity-0 absolute"
                v-model="newEdit"
                @click="toggleGbMethods()"
              />
              <svg
                class="fill-current stroke-current stroke-2 hidden w-3 h-3 text-white pointer-events-none"
                viewBox="0 0 20 20"
              >
                <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
              </svg>
            </div>
            <div>
              <span class="speedee-bd">Anmeldung Geburtstagspost</span> - wir
              feiern mit euch den wichtigsten Tag im Jahr! Geburtstagskindern
              schicken wir eine besondere Überraschung per Post.
            </div>
          </label>
          <!-- Check box GB END -->
          <!-- EDIT NEW START -->
          <template v-if="newEdit">
            <div class="lg:pl-10 pt-4">
              <!-- New or Edit START -->
              <label
                class="flex justify-start items-start pb-4"
                @click="submitStatus = null"
              >
                <div
                  class="rounded-full w-6 h-6 flex flex-shrink-0 justify-center items-center mr-4"
                  :class="[isNew ? 'bg-mcdonalds-yellow' : 'bg-mcdonalds-gray']"
                >
                  <input
                    type="checkbox"
                    name="gb"
                    class="opacity-0 absolute"
                    v-model="isNew"
                    @click="toggleNew()"
                  />
                  <svg
                    class="fill-current stroke-current stroke-2 hidden w-3 h-3 text-white pointer-events-none"
                    viewBox="0 0 20 20"
                  >
                    <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                  </svg>
                </div>
                <div>
                  <p class="font-light">Ich möchte mich anmelden.</p>
                </div>
              </label>
              <label
                class="flex justify-start items-start pb-4"
                @click="submitStatus = null"
              >
                <div
                  class="rounded-full w-6 h-6 flex flex-shrink-0 justify-center items-center mr-4"
                  :class="[
                    isEdit ? 'bg-mcdonalds-yellow' : 'bg-mcdonalds-gray',
                  ]"
                >
                  <input
                    type="checkbox"
                    name="gb"
                    class="opacity-0 absolute"
                    v-model="isEdit"
                    @click="toggleEdit()"
                  />
                  <svg
                    class="fill-current stroke-current stroke-2 hidden w-3 h-3 text-white pointer-events-none"
                    viewBox="0 0 20 20"
                  >
                    <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                  </svg>
                </div>
                <div>
                  <p class="font-light">
                    Ich bin bereits angemeldet und möchte meine Daten ändern
                    z.B. ein Kind hinzufügen.
                  </p>
                </div>
              </label>
            </div>
            <!-- New or Edit END -->
          </template>
          <!-- EDIT NEW END -->
          <!-- Name, last name GB START -->
          <template v-if="isEdit">
            <EditGb class="lg:pl-10" />
          </template>
          <template v-if="gb.isVisible">
            <div class="lg:pl-10">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-y-2 gap-x-4">
                <div>
                  <input
                    class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                    type="text"
                    name="gb_name"
                    placeholder="Vorname Elternteil*"
                    v-model.trim="$v.gb.gb_name.$model"
                    :class="[
                      submitStatus == 'ERROR' && !$v.gb.gb_name.required
                        ? 'error'
                        : '',
                    ]"
                  />
                  <div class="text-red-600 text-sm pt-1 md:pt-2">
                    <p
                      v-if="submitStatus == 'ERROR' && !$v.gb.gb_name.required"
                    >
                      Erforderlich
                    </p>
                  </div>
                </div>
                <div>
                  <input
                    class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                    type="text"
                    name="gb_lastname"
                    placeholder="Nachname Elternteil*"
                    v-model.trim="$v.gb.gb_lastname.$model"
                    :class="[
                      submitStatus == 'ERROR' && !$v.gb.gb_lastname.required
                        ? 'error'
                        : '',
                    ]"
                  />
                  <div class="text-red-600 text-sm pt-2">
                    <p
                      v-if="
                        submitStatus == 'ERROR' && !$v.gb.gb_lastname.required
                      "
                    >
                      Erforderlich
                    </p>
                  </div>
                </div>
              </div>
              <!-- Name, last name GB END -->
              <!-- Address GB START -->
              <div class="grid grid-cols-4 gap-x-4 gap-y-1 pt-1">
                <div class="col-span-4 md:col-span-2">
                  <input
                    class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                    type="text"
                    name="gb_street"
                    placeholder="Straße*"
                    v-model.trim="$v.gb.gb_street.$model"
                    :class="[
                      submitStatus == 'ERROR' && !$v.gb.gb_street.required
                        ? 'error'
                        : '',
                    ]"
                  />
                  <div class="text-red-600 text-sm pt-2">
                    <p
                      v-if="
                        submitStatus == 'ERROR' && !$v.gb.gb_street.required
                      "
                    >
                      Erforderlich
                    </p>
                  </div>
                </div>
                <div class="col-span-2 md:col-span-1">
                  <input
                    class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                    type="text"
                    name="gb_number"
                    placeholder="Hausnr.*"
                    v-model.trim="$v.gb.gb_number.$model"
                    :class="[
                      submitStatus == 'ERROR' && !$v.gb.gb_number.required
                        ? 'error'
                        : '',
                    ]"
                  />
                  <div class="text-red-600 text-sm pt-2">
                    <p
                      v-if="
                        submitStatus == 'ERROR' && !$v.gb.gb_number.required
                      "
                    >
                      Erforderlich
                    </p>
                  </div>
                </div>
                <div class="col-span-2 md:col-span-1">
                  <input
                    class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                    type="text"
                    name="gb_top"
                    placeholder="Top/Stiege"
                    v-model="gb.gb_top"
                  />
                </div>
                <div class="col-span-4 md:col-span-1">
                  <input
                    class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                    type="text"
                    name="gb_plz"
                    placeholder="PLZ*"
                    v-model.trim="$v.gb.gb_plz.$model"
                    :class="[
                      submitStatus == 'ERROR' && !$v.gb.gb_plz.required
                        ? 'error'
                        : '',
                    ]"
                  />
                  <div class="text-red-600 text-sm pt-2">
                    <p v-if="submitStatus == 'ERROR' && !$v.gb.gb_plz.required">
                      Erforderlich
                    </p>
                  </div>
                </div>
                <div class="col-span-4 md:col-span-3">
                  <input
                    class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                    type="text"
                    name="gb_city"
                    placeholder="Ort*"
                    v-model.trim="$v.gb.gb_city.$model"
                    :class="[
                      submitStatus == 'ERROR' && !$v.gb.gb_city.required
                        ? 'error'
                        : '',
                    ]"
                  />
                  <div class="text-red-600 text-sm pt-2">
                    <p
                      v-if="submitStatus == 'ERROR' && !$v.gb.gb_city.required"
                    >
                      Erforderlich
                    </p>
                  </div>
                </div>
              </div>
              <!-- Name, month, year GB child START -->
              <div
                v-for="(child, index) in gb.gb_childs"
                :key="index"
                class="pt-8 md:pt-0"
              >
                <GbChild :child="child" ref="childrenComponent" />
                <!-- Remove Child START -->
                <div v-if="index > 0" class="mt-6 md:mt-0">
                  <div
                    class="inline-block bg-mcdonalds-gray px-4 py-2 rounded-full mt-4 w-full md:w-60 shadow-mcd"
                  >
                    <div class="flex items-center justify-between">
                      <div class="inline-block pl-2 speedee-bd text-sm">
                        Kind entfernen
                      </div>
                      <div class="inline-block">
                        <div
                          class="flex justify-center items-center w-8 h-8 md:w-6 md:h-6 text-white speedee-bd cursor-pointer ml-4"
                          @click="removeChild(index)"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 50 50"
                            class="fill-current stroke-current stroke-2 w-6 h-6 md:w-5 md:h-5"
                          >
                            <g>
                              <path d="M4.3,28.53v-7.18h41.4v7.18H4.3z" />
                            </g>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Remove Child END -->
                <!-- Name, month, year GB child END -->
              </div>
              <!-- Add Child START -->
              <div
                v-if="gb.isVisible && gb.gb_childs.length < 4"
                class="mb-12 md:mb-0"
              >
                <div
                  class="inline-block bg-mcdonalds-yellow px-4 py-2 rounded-full mt-4 w-full md:w-60 shadow-mcd"
                >
                  <div class="flex items-center justify-between">
                    <div class="inline-block pl-2 speedee-bd text-sm">
                      Weiteres Kind hinzufügen
                    </div>
                    <div class="inline-block">
                      <div
                        class="flex justify-center items-center w-8 h-8 md:w-6 md:h-6 text-white speedee-bd cursor-pointer ml-4"
                        @click="addChild"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 50 50"
                          class="fill-current stroke-current stroke-2 w-6 h-6 md:w-5 md:h-5"
                        >
                          <g>
                            <path
                              d="M21.36,45.7V28.53H4.3v-7.18h17.07V4.3h7.27v17.05H45.7v7.18H28.64V45.7H21.36z"
                            />
                          </g>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Add Child END -->
            </div>
          </template>
          <!-- Address GB END -->
        </div>
        <!-- GB END -->
        <!-- TIPI START -->

        <div class="pt-8">
          <!-- Check box TIPI START -->
          <label
            class="flex justify-start items-start pb-4"
            @click="submitStatus = null"
          >
            <div
              class="rounded-md w-6 h-6 flex flex-shrink-0 justify-center items-center mr-4"
              :class="[
                newEditTipi ? 'bg-mcdonalds-yellow' : 'bg-mcdonalds-gray',
              ]"
            >
              <input
                type="checkbox"
                name="tipi"
                class="opacity-0 absolute"
                v-model="newEditTipi"
                @click="toggleTipiMethods()"
              />
              <svg
                class="fill-current stroke-current stroke-2 hidden w-3 h-3 text-white pointer-events-none"
                viewBox="0 0 20 20"
              >
                <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
              </svg>
            </div>
            <div>
              <span class="speedee-bd">Anmeldung Tipi Magazin</span> - erhalte
              das Familienmagazin 4x im Jahr kostenlos nach Hause!
            </div>
          </label>
          <!-- Check box TIPI END -->

          <!-- EDIT TIPI START -->
          <template v-if="newEditTipi">
            <div class="lg:pl-10 pt-4">
              <!-- New or Edit START -->
              <label
                class="flex justify-start items-start pb-4"
                @click="submitStatus = null"
              >
                <div
                  class="rounded-full w-6 h-6 flex flex-shrink-0 justify-center items-center mr-4"
                  :class="[
                    isNewTipi ? 'bg-mcdonalds-yellow' : 'bg-mcdonalds-gray',
                  ]"
                >
                  <input
                    type="checkbox"
                    name="tipi"
                    class="opacity-0 absolute"
                    v-model="isNewTipi"
                    @click="toggleNewTipi()"
                  />
                  <svg
                    class="fill-current stroke-current stroke-2 hidden w-3 h-3 text-white pointer-events-none"
                    viewBox="0 0 20 20"
                  >
                    <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                  </svg>
                </div>
                <div>
                  <p class="font-light">Ich möchte mich anmelden.</p>
                </div>
              </label>
              <label
                class="flex justify-start items-start pb-4"
                @click="submitStatus = null"
              >
                <div
                  class="rounded-full w-6 h-6 flex flex-shrink-0 justify-center items-center mr-4"
                  :class="[
                    isEditTipi ? 'bg-mcdonalds-yellow' : 'bg-mcdonalds-gray',
                  ]"
                >
                  <input
                    type="checkbox"
                    name="tipi"
                    class="opacity-0 absolute"
                    v-model="isEditTipi"
                    @click="toggleEditTipi()"
                  />
                  <svg
                    class="fill-current stroke-current stroke-2 hidden w-3 h-3 text-white pointer-events-none"
                    viewBox="0 0 20 20"
                  >
                    <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                  </svg>
                </div>
                <div>
                  <p class="font-light">
                    Ich bin bereits angemeldet und möchte meine Adresse ändern
                  </p>
                </div>
              </label>
            </div>
            <!-- New or Edit END -->
          </template>
          <!-- EDIT NEW END -->
          <!-- Name, last name GB START -->
          <template v-if="isEditTipi">
            <EditTipi class="lg:pl-10" />
          </template>

          <!-- Name, last name TIPI START -->
          <template v-if="tipi.isVisible">
            <div class="lg:pl-10">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-y-2 gap-x-4">
                <div>
                  <input
                    class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                    type="text"
                    name="tipi_name"
                    placeholder="Vorname*"
                    v-model.trim="$v.tipi.tipi_name.$model"
                    :class="[
                      submitStatus == 'ERROR' && !$v.tipi.tipi_name.required
                        ? 'error'
                        : '',
                    ]"
                  />
                  <div class="text-red-600 text-sm pt-1 md:pt-2">
                    <p
                      v-if="
                        submitStatus == 'ERROR' && !$v.tipi.tipi_name.required
                      "
                    >
                      Erforderlich
                    </p>
                  </div>
                </div>
                <div>
                  <input
                    class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                    type="text"
                    name="tipi_lastname"
                    placeholder="Nachname*"
                    v-model.trim="$v.tipi.tipi_lastname.$model"
                    :class="[
                      submitStatus == 'ERROR' && !$v.tipi.tipi_lastname.required
                        ? 'error'
                        : '',
                    ]"
                  />
                  <div class="text-red-600 text-sm pt-2">
                    <p
                      v-if="
                        submitStatus == 'ERROR' &&
                          !$v.tipi.tipi_lastname.required
                      "
                    >
                      Erforderlich
                    </p>
                  </div>
                </div>
              </div>
              <!-- Name, last name TIPI END -->
              <!-- Address TIPI START -->
              <div class="grid grid-cols-4 gap-x-4 gap-y-1 pt-1 pb-12 md:pb-0">
                <div class="col-span-4 md:col-span-2">
                  <input
                    class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                    type="text"
                    name="tipi_street"
                    placeholder="Straße*"
                    v-model.trim="$v.tipi.tipi_street.$model"
                    :class="[
                      submitStatus == 'ERROR' && !$v.tipi.tipi_street.required
                        ? 'error'
                        : '',
                    ]"
                  />
                  <div class="text-red-600 text-sm pt-2">
                    <p
                      v-if="
                        submitStatus == 'ERROR' && !$v.tipi.tipi_street.required
                      "
                    >
                      Erforderlich
                    </p>
                  </div>
                </div>
                <div class="col-span-2 md:col-span-1">
                  <input
                    class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                    type="text"
                    name="tipi_number"
                    placeholder="Hausnr.*"
                    v-model.trim="$v.tipi.tipi_number.$model"
                    :class="[
                      submitStatus == 'ERROR' && !$v.tipi.tipi_number.required
                        ? 'error'
                        : '',
                    ]"
                  />
                  <div class="text-red-600 text-sm pt-2">
                    <p
                      v-if="
                        submitStatus == 'ERROR' && !$v.tipi.tipi_number.required
                      "
                    >
                      Erforderlich
                    </p>
                  </div>
                </div>
                <div class="col-span-2 md:col-span-1">
                  <input
                    class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                    type="text"
                    name="tipi_top"
                    placeholder="Top/Stiege"
                    v-model="tipi.tipi_top"
                  />
                </div>
                <div class="col-span-4 md:col-span-1">
                  <input
                    class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                    type="text"
                    name="tipi_plz"
                    placeholder="PLZ*"
                    v-model.trim="$v.tipi.tipi_plz.$model"
                    :class="[
                      submitStatus == 'ERROR' && !$v.tipi.tipi_plz.required
                        ? 'error'
                        : '',
                    ]"
                  />
                  <div class="text-red-600 text-sm pt-2">
                    <p
                      v-if="
                        submitStatus == 'ERROR' && !$v.tipi.tipi_plz.required
                      "
                    >
                      Erforderlich
                    </p>
                  </div>
                </div>
                <div class="col-span-4 md:col-span-3">
                  <input
                    class="w-full col-span-3 bg-white h-14 px-5 rounded focus:outline-none"
                    type="text"
                    name="tipi_city"
                    placeholder="Ort*"
                    v-model.trim="$v.tipi.tipi_city.$model"
                    :class="[
                      submitStatus == 'ERROR' && !$v.tipi.tipi_city.required
                        ? 'error'
                        : '',
                    ]"
                  />
                  <div class="text-red-600 text-sm pt-2">
                    <p
                      v-if="
                        submitStatus == 'ERROR' && !$v.tipi.tipi_city.required
                      "
                    >
                      Erforderlich
                    </p>
                  </div>
                </div>
              </div>
              <!-- Address TIPI END -->
            </div>
          </template>
        </div>
        <!-- TIPI END -->
        <div class="pt-4">
          <!-- Check box GPDR START -->
          <label class="flex justify-start items-start pb-2">
            <div
              class="rounded-md w-6 h-6 flex flex-shrink-0 justify-center items-center mr-4"
              :class="[
                submitStatus == 'ERROR' && $v.checkConditions.$error
                  ? 'error'
                  : '',
                checkConditions ? 'bg-mcdonalds-yellow' : 'bg-mcdonalds-gray',
              ]"
            >
              <input
                type="checkbox"
                name="tipi"
                class="opacity-0 absolute"
                v-model.trim="checkConditions"
                @change="$v.checkConditions.$touch()"
              />
              <svg
                class="fill-current stroke-current stroke-2 hidden w-3 h-3 text-white pointer-events-none"
                viewBox="0 0 20 20"
              >
                <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
              </svg>
            </div>
            <div class="select-none font-light">
              *Ich stimme den
              <a
                href="https://www.mcdonalds.at/familyplus/agb"
                class="underline text-mcdonalds-yellow"
                >Nutzungsbedingungen</a
              >
              zu und nehme die<br />
              <a
                href="https://www.mcdonalds.at/datenschutz"
                class="underline text-mcdonalds-yellow"
                >Datenschutzerklärung</a
              >
              zur Kenntnis.
            </div>
          </label>
          <!-- Check box GPDR END -->
          <!-- Check Conditions NL START -->
          <div class="pt-8" v-if="nl.isVisible">
            <label class="flex justify-start items-start pb-4">
              <div
                class="rounded-md w-6 h-6 flex flex-shrink-0 justify-center items-center mr-4"
                :class="[
                  submitStatus == 'ERROR' && $v.nl.checkConditions.$error
                    ? 'error'
                    : '',
                  nl.checkConditions
                    ? 'bg-mcdonalds-yellow'
                    : 'bg-mcdonalds-gray',
                ]"
              >
                <input
                  type="checkbox"
                  name="nl"
                  class="opacity-0 absolute"
                  v-model="nl.checkConditions"
                />
                <svg
                  class="fill-current stroke-current stroke-2 hidden w-3 h-3 text-white pointer-events-none"
                  viewBox="0 0 20 20"
                >
                  <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                </svg>
              </div>
              <div class="select-none font-light">
                *Ich stimme zu, dass die McDonald's Werbegesellschaft m.b.H. mir
                Newsletter und allgemeine Informationen zu familienrelevanten
                Themen per E-Mail zusendet. Diese Zustimmung kann ich auch
                nachträglich jederzeit gegenüber McDonald's per E-Mail an
                datenschutz@at.mcd.com widerrufen. Der Widerruf lässt die
                Rechtmäßigkeit der Verarbeitung bis zum Widerruf unberührt.
              </div>
            </label>
          </div>
          <!-- Check Conditions NL END -->
          <!-- Check Conditions GB START -->
          <div class="pt-8" v-if="gb.isVisible">
            <label class="flex justify-start items-start pb-4">
              <div
                class="rounded-md w-6 h-6 flex flex-shrink-0 justify-center items-center mr-4"
                :class="[
                  submitStatus == 'ERROR' && $v.gb.checkConditions.$error
                    ? 'error'
                    : '',
                  gb.checkConditions
                    ? 'bg-mcdonalds-yellow'
                    : 'bg-mcdonalds-gray',
                ]"
              >
                <input
                  type="checkbox"
                  name="nl"
                  class="opacity-0 absolute"
                  v-model="gb.checkConditions"
                />
                <svg
                  class="fill-current stroke-current stroke-2 hidden w-3 h-3 text-white pointer-events-none"
                  viewBox="0 0 20 20"
                >
                  <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                </svg>
              </div>
              <div class="select-none font-light" v-if="gb.isVisible">
                *Ich stimme in meinem Namen und im Namen meines Kindes (meiner
                Kinder) zu, dass die McDonald's Werbegesellschaft m.b.H. die
                angegebenen Daten verarbeitet, um mir für mein Kind (meine
                Kinder) (im Alter zwischen 3 und 12 Jahren) einen
                Geburtstagsgutschein per Post zusendet. Diese Zustimmung kann
                ich auch nachträglich jederzeit gegenüber McDonald’s per E-Mail
                an datenschutz@at.mcd.com widerrufen. Der Widerruf lässt die
                Rechtmäßigkeit der Verarbeitung bis zum Widerruf unberührt.
              </div>
            </label>
          </div>
          <!-- Check Conditions GB END -->
          <!-- Check Conditions TIPI START -->
          <div class="pt-8" v-if="tipi.isVisible">
            <label class="flex justify-start items-start pb-4">
              <div
                class="rounded-md w-6 h-6 flex flex-shrink-0 justify-center items-center mr-4"
                :class="[
                  submitStatus == 'ERROR' && $v.tipi.checkConditions.$error
                    ? 'error'
                    : '',
                  tipi.checkConditions
                    ? 'bg-mcdonalds-yellow'
                    : 'bg-mcdonalds-gray',
                ]"
              >
                <input
                  type="checkbox"
                  name="nl"
                  class="opacity-0 absolute"
                  v-model="tipi.checkConditions"
                />
                <svg
                  class="fill-current stroke-current stroke-2 hidden w-3 h-3 text-white pointer-events-none"
                  viewBox="0 0 20 20"
                >
                  <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                </svg>
              </div>
              <div class="select-none font-light">
                *Ich stimme zu, dass die McDonald’s Werbegesellschaft m.b.H. mir
                viermal jährlich das Tipi Magazin per Post zusendet. Diese
                Zustimmung kann ich auch nachträglich jederzeit gegenüber
                McDonald’s per E-Mail an datenschutz@at.mcd.com widerrufen. Der
                Widerruf lässt die Rechtmäßigkeit der Verarbeitung bis zum
                Widerruf unberührt.
              </div>
            </label>
          </div>
          <!-- Check Conditions TIPI END -->
          <!-- reCaptcha Start -->
          <div class="flex justify-center">
            <div class="relative">
              <vue-recaptcha
                class="mt-4 cyb-recaptcha"
                sitekey="6Lcg8FsaAAAAAIT8aqLptBxRl2c7kmZFjw2qQYYB"
                :loadRecaptchaScript="true"
                ref="recaptcha"
                @verify="onVerify"
                @expired="onExpired"
                @render="onRender"
              ></vue-recaptcha>
              <div class="text-red-600 text-sm pt-2">
                <p v-if="submitStatus == 'ERROR' && !$v.reCpatcha.required">
                  Erforderlich
                </p>
              </div>
            </div>
          </div>
          <!-- reCaptcha End -->
        </div>
        <div class="flex justify-center md:pt-12">
          <button
            class="bg-mcdonalds-yellow rounded-full py-4 px-12 md:px-16 text-black text-xl speedee-bd mt-4 focus:outline-none"
            @click="validateForm()"
          >
            Absenden
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  reCaptchaMixin,
  refererApiMixin,
  gbChildMixin,
  scrollToIdMixin,
} from "../mixins";
import VueRecaptcha from "vue-recaptcha";
import Preloader from "./Preloader";
import EditGb from "./EditGb";
import EditTipi from "./EditTipi";
import GbChild from "./GbChild";
import RegistrationSuccessMessage from "./Messages/RegistrationSuccess.vue";
import { ValidationRules } from "./ValidationRules.js";

export default {
  components: {
    Preloader,
    EditGb,
    EditTipi,
    GbChild,
    RegistrationSuccessMessage,
    VueRecaptcha,
  },
  data() {
    return {
      submitStatus: null,
      reCpatcha: "",
      newEdit: false,
      newEditTipi: false,
      isEdit: false,
      isEditTipi: false,
      isNewTipi: false,
      isNew: false,
      changegb: true,
      changetipi: true,
      web: false,
      mob: false,
      app: false,
      email: "",
      nl: {
        isVisible: false,
        checkConditions: false,
      },
      tipi: {
        isVisible: false,
        checkConditions: false,
        tipi_name: "",
        tipi_lastname: "",
        tipi_street: "",
        tipi_number: null,
        tipi_plz: null,
        tipi_city: "",
        tipi_top: "",
      },
      gb: {
        isVisible: false,
        checkConditions: false,
        gb_name: "",
        gb_lastname: "",
        gb_street: "",
        gb_number: null,
        gb_top: "",
        gb_plz: null,
        gb_city: "",
        gb_childs: [],
        gb_child_db: [],
      },
      checkConditions: false,
      validationSuccessChildren: false,
    };
  },
  validations() {
    return ValidationRules;
  },
  mixins: [reCaptchaMixin, refererApiMixin, gbChildMixin, scrollToIdMixin],
  watch: {
    "nl.isVisible": function(val) {
      if (!val) {
        this.nl.checkConditions = false;
      }
    },
    "gb.isVisible": function(val) {
      if (!val) {
        this.gb.checkConditions = false;
      }
    },
    "tipi.isVisible": function(val) {
      if (!val) {
        this.tipi.checkConditions = false;
      }
    },
  },
  methods: {
    toggleGbMethods() {
      if (this.newEdit) {
        this.isNew = false;
        this.isEdit = false;
        this.newEdit = false;
        this.gb.isVisible = false;
      }
    },
    toggleNew() {
      if (!this.isNew) {
        this.isNew = true;
        this.isEdit = false;
        this.gb.isVisible = true;
        this.addFirstChild();
      } else {
        this.isEdit = true;
        this.isNew = false;
        this.gb.isVisible = false;
      }
    },
    toggleEdit() {
      if (!this.isEdit) {
        this.isEdit = true;
        this.isNew = false;
        this.gb.isVisible = false;
      } else {
        this.isEdit = false;
        this.isNew = true;
        this.gb.isVisible = true;
        this.addFirstChild();
      }
    },
    // Tipi Toggle Methods
    toggleTipiMethods() {
      if (this.newEditTipi) {
        this.isNewTipi = false;
        this.isEditTipi = false;
        this.newEditTipi = false;
        this.tipi.isVisible = false;
      }
    },
    toggleNewTipi() {
      if (!this.isNewTipi) {
        this.isNewTipi = true;
        this.isEditTipi = false;
        this.tipi.isVisible = true;
      } else {
        this.isEditTipi = true;
        this.isNewTipi = false;
        this.tipi.isVisible = false;
      }
    },
    toggleEditTipi() {
      if (!this.isEditTipi) {
        this.isEditTipi = true;
        this.isNewTipi = false;
        this.tipi.isVisible = false;
      } else {
        this.isEditTipi = false;
        this.isNewTipi = true;
        this.tipi.isVisible = true;
      }
    },
    // method to validate child components
    async validateForm() {
      // run vuelidate and check if there some errors
      this.$v.$touch();
      // if checkbox is checked/true
      if (this.gb.isVisible) {
        // then run loop trough array and check each component validation.
        for (const [i, child] of this.gb.gb_childs.entries()) {
          // call method submit in each child component
          this.$refs.childrenComponent[i].submit();
          // if validation is success, then set value to true
          if (child.validationSuccess) {
            this.validationSuccessChildren = true;
          } else {
            this.validationSuccessChildren = false;
          }
        }
      }

      // if validation is false
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        // add child to gb child
        if (this.gb.gb_childs.length > 0) {
          this.generateChildrenArray();
        }

        let formData = new FormData();
        // create a json object from values to send to API
        let data = {
          email: this.email,
          nl: this.nl.isVisible,
          tipi: this.tipi.isVisible,
          tipi_name: this.tipi.tipi_name,
          tipi_lastname: this.tipi.tipi_lastname,
          tipi_street: this.tipi.tipi_street,
          tipi_number: this.tipi.tipi_number,
          tipi_top: this.tipi.tipi_top,
          tipi_plz: this.tipi.tipi_plz,
          tipi_city: this.tipi.tipi_city,
          gb: this.gb.isVisible,
          gb_name: this.gb.gb_name,
          gb_lastname: this.gb.gb_lastname,
          gb_street: this.gb.gb_street,
          gb_number: this.gb.gb_number,
          gb_top: this.gb.gb_top,
          gb_plz: this.gb.gb_plz,
          gb_city: this.gb.gb_city,
          gb_childs: this.gb.gb_child_db,
        };

        formData.append("data", JSON.stringify(data));
        formData.append("g-recaptcha-response", this.reCpatcha);

        if (this.gb.isVisible || this.tipi.isVisible || this.nl.isVisible) {
          // if validation is true, but if child checkbox is checked/true
          if (this.gb.isVisible && this.validationSuccessChildren) {
            const registerUser = await this.sendDataToApi(formData);
          } else if (!this.gb.isVisible) {
            try {
              // send API request to back end
              const registerUser = await this.sendDataToApi(formData);
            } catch (error) {
              this.$swal({
                icon: "error",
                title: error,
              });
            }
          }
        } else {
          this.$swal({
            icon: "error",
            title:
              "Hoppla, du hast kein Angebot ausgewählt. Versuch‘s nochmal!",
          });
        }
      }
    },
    async sendDataToApi(formData) {
      //setup headers, method and values
      const settings = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          "X-Requested-With": "XMLHttpRequest",
        },
      };

      this.submitStatus = "LOADING";
      this.axios
        .post(
          process.env.VUE_APP_WEBSERVICE_URL + "/?action=register",
          formData,
          settings
        )
        .then(
          // get response if success
          async (dataRes) => {
            this.submitStatus = "OK";
            this.$refs.recaptcha.reset();
            this.scrollToId();
          }
          // catch the errors
        )
        .catch(function(error) {
          this.$swal({
            icon: "error",
            title: error,
          });
        });
    },
  },
  mounted() {
    this.gb.isVisible = false;
    this.tipi.isVisible = false;
    // on load check if url params are set and set the in a variable
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    // get paramaters by name
    const from = urlParams.get("from");
    const changegb = urlParams.get("changegb");
    const changetipi = urlParams.get("changetipi");
    const email = urlParams.get("email");
    if (changegb) {
      this.changegb = changegb;
    }
    if (changetipi) {
      this.changetipi = changetipi;
    }
    // call the values from parameters and set them in variables
    if (from == "app") {
      this.app = true;
    } else {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        this.mob = true;
      } else {
        this.web = true;
      }
    }
    // call the function to set referer values
    this.sendRefererToApi();
    // if parameter email ist set, then set value in email variable
    if (email) {
      this.email = email;
    }
  },
};
</script>
